export default __webpack_public_path__ + "static/media/information--end-of-car-pool-lane--g1.83bbacf0.png";